import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'

const REASONS = ['Chỉ quá tương phản', 'Chỉ bị chìm', 'Sai tông so với artwork', 'Khác']

const COLOR_NAME = { WHITE: 'TRẮNG', BLACK: 'ĐEN', GREY: 'GHI', RED: 'ĐỎ', UNRESOLVED: 'CHƯA XÁC ĐỊNH' }

const ChangeReasonBlock = ({ currentColor, newColor, loading, onSelectReason, onSkipReason, onCancel }) => {
    const currentColorName = currentColor === null ? COLOR_NAME.UNRESOLVED : COLOR_NAME[currentColor]

    return (
        <div className="ChangeReasonBlock">
            <div className="ChangeReasonBlock__title">
                Đổi {currentColorName} → {COLOR_NAME[newColor]}. Chọn lý do để xác nhận:
            </div>

            <div className="d-flex flex-wrap">
                {REASONS.map(reason => (
                    <Button
                        key={reason}
                        className="ReasonPill"
                        disabled={loading}
                        onClick={() => onSelectReason(reason)}
                    >
                        {reason}
                    </Button>
                ))}
            </div>
            <div className="d-flex flex-wrap mb-3">
                <Button className="ReasonPill ReasonPill--skip" disabled={loading} onClick={onSkipReason}>
                    Bỏ qua lý do
                </Button>
            </div>

            <p className="ChangeReasonBlock__note">
                Chạm một lý do = xác nhận. Item <strong>không</strong> bị đánh lỗi và <strong>không</strong> phải tái tạo.
            </p>

            <Button className="CancelBtn" disabled={loading} onClick={onCancel}>Hủy</Button>
        </div>
    )
}

ChangeReasonBlock.propTypes = {
    currentColor: PropTypes.string,
    newColor: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    onSelectReason: PropTypes.func.isRequired,
    onSkipReason: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
}

export default ChangeReasonBlock
